module.exports = __webpack_public_path__ + "static/media/gamepad-alt.0afc3e65.svg";